export const TIMEZONES_CALL = "TIMEZONES_CALL";

export function callTimezones() {
  return { type: TIMEZONES_CALL };
}
